import { useLocation } from 'react-router-dom';

function useSimulator() {
  const location = useLocation();
  return /simulator/.test(location.search);
}

export default useSimulator;
